import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { ReactNode, useEffect, useRef, useState } from "react";

export function AppQueryProvider({ children }: { children: ReactNode }) {
  const [client] = useState(
    () =>
      new QueryClient({
        defaultOptions: {
          queries: {
            refetchOnWindowFocus: false,
            retry: (failureCount, error: any) => {
              if (error?.status && error.status >= 500) {
                return false;
              }
              return failureCount < 6;
            },
          },
        },
      })
  );
  const Devtools = useDevtools();
  return (
    <QueryClientProvider client={client}>
      {children}
      {Devtools}
    </QueryClientProvider>
  );
}

function useDevtools() {
  const ref = useRef<ReactNode>(null);
  useEffect(() => {
    if (import.meta.env.DEV) {
      import("@tanstack/react-query-devtools").then((m) => {
        ref.current = <m.ReactQueryDevtools initialIsOpen={false} />;
      });
    }
  }, []);
  return ref.current;
}
